import { categories, type CategoryEntry } from '@/mocks/homeData';

const toneMap: Record<CategoryEntry['tone'], string> = {
  primary: 'text-primary-700 bg-primary-100',
  accent: 'text-accent-700 bg-accent-100',
  secondary: 'text-secondary-900 bg-secondary-100',
};

export default function CategoryGrid() {
  return (
    <section id="category" className="w-full border-y border-background-200 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 max-w-2xl">
          <p className="text-xs font-semibold tracking-[0.2em] text-primary-600">LIBRARY · 扒哥黑料资料库</p>
          <h3 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">
            按题材整库检索，历史黑料分门别类
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            扒哥黑料汇总按题材分区归档，每条备注时间与出处，方便按人物、按平台、按事件回溯备查。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <article
              key={c.id}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${toneMap[c.tone]}`}>
                  <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs font-semibold text-foreground-500">{c.count}</span>
              </div>

              <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">
                <a href="#archive" className="group-hover:text-primary-700">
                  {c.name}
                </a>
              </h4>
              <p className="mt-0.5 text-[11px] font-medium tracking-[0.16em] text-foreground-400">{c.en}</p>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>

              <a
                href="#archive"
                className="mt-4 inline-flex items-center gap-1 self-start whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50"
              >
                进入档案
                <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}